import React from 'react';

import ChevronDownSvg from 'assets/images/chevron-down.svg';

import BaseIcon from './BaseIcon';

const ChevronDownIcon = props => (
  <BaseIcon {...props} src={ChevronDownSvg} />
);

export default ChevronDownIcon;
